// SelectionBar — Dock-Zeile im Auswahl-Modus: Batch-Aktionen für die markierten Karten.
// Nimmt den Platz der Editor-Zeile in MobileFilterStrip.DockBar ein.
import React from 'react';
import { ListEnd, Minus, Plus, Tag, Trash2 } from 'lucide-react';

/**
 * Nur die erlaubten Aktionen erscheinen: ohne Bearbeitungsrecht (`canEdit`, z.B. physisches
 * Deck) bleiben Kategorie und Label übrig, Kategorie zusätzlich nur in einem
 * editierbaren Gruppier-Modus (`canMove`). `count === 0` kommt in der Praxis nicht vor —
 * das Demarkieren der letzten Karte beendet den Auswahl-Modus, der diese Leiste zeigt.
 * Die Sperre bleibt als Absicherung stehen.
 *
 * Beschriftet ist nur der Kategorie-Knopf: Fünf Aktionen mit Wort passen nicht in eine
 * Zeile — bei 360px Bildschirmbreite stehen der Zeile 312px zur Verfügung, drei
 * beschriftete Knöpfe brauchen allein 259px. Label und Löschen tragen deshalb nur ihr
 * Symbol (Benennung über `aria-label`/`title`); ihre Symbole sind die eindeutigsten der
 * Zeile. Auf sehr schmalen Geräten (≤320px) fällt zusätzlich das Symbol des
 * Kategorie-Knopfs weg — sein Wort bleibt dabei vollständig lesbar.
 */
export default function SelectionBar({
  count = 0,
  canEdit = false,
  canMove = false,
  onMove,
  onLabel,
  onQuantityDelta,
  onDelete,
}) {
  const disabled = count === 0;

  return (
    <div className="mobile-selection-bar">
      {canMove && (
        <button
          type="button"
          className="btn-secondary mobile-selection-bar__action"
          onClick={onMove}
          disabled={disabled}
        >
          <ListEnd size={16} aria-hidden /> Kategorie
        </button>
      )}
      <button
        type="button"
        className="btn-secondary mobile-selection-bar__icon"
        aria-label="Label vergeben"
        title="Label vergeben"
        onClick={onLabel}
        disabled={disabled}
      >
        <Tag size={16} aria-hidden />
      </button>
      {canEdit && (
        <>
          <button
            type="button"
            className="btn-secondary mobile-selection-bar__icon"
            aria-label="Menge verringern"
            title="Menge verringern"
            onClick={() => onQuantityDelta?.(-1)}
            disabled={disabled}
          >
            <Minus size={16} aria-hidden />
          </button>
          <button
            type="button"
            className="btn-secondary mobile-selection-bar__icon"
            aria-label="Menge erhöhen"
            title="Menge erhöhen"
            onClick={() => onQuantityDelta?.(1)}
            disabled={disabled}
          >
            <Plus size={16} aria-hidden />
          </button>
          <button
            type="button"
            className="btn-danger mobile-selection-bar__icon"
            aria-label="Karten löschen"
            title="Karten löschen"
            onClick={onDelete}
            disabled={disabled}
          >
            <Trash2 size={16} aria-hidden />
          </button>
        </>
      )}
    </div>
  );
}
